import React, { useEffect, useState } from 'react'
import esLocale from "date-fns/locale/es";
import DateFnsUtils from "@date-io/date-fns";
import NumberFormat from 'react-number-format';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { AutorizacionesBuscador } from '../../autorizaciones/Ingreso/AutorizacionesBuscador';
import {
    Checkbox,
    FormControl,
    FormControlLabel,
    FormGroup,
    Grid,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    TextField
} from '@material-ui/core';
import { CATEGORIAS_VALORIZACIONES_ARRAY, LIQUIDACIONES_LINEA_COMPORBANTE, OBRAS_SOCIALES } from '../../../utils/constants';
import BuscadorMedicamento from '../../empadronamiento/Ingreso/BuscadorMedicamento';
import DebitoCapita from '../../autorizaciones/gestionAuditoria/DebitoCapita';
import { getValorMedicamento } from '../../../actions/liquidaciones/liquidaciones';
import { useDispatch, useSelector } from 'react-redux';
import { getObrasSociales } from '../../../actions/afiliado';
import { BuscadorAfiliadosExternos } from '../UI/BuscadorAfiliadosExternos';

export const ModalAddLineCampos = ({ esLineaCodigoLiq, lineaComprobante, lineaExistente, comprobanteSeleccionado,
    cantidad, setCantidad, idCategoria, setIdCategoria, afiliadoTemp, setAfiliadoTemp, nroValidacion,
    setNroValidacion, afiInexistente, setAfiInexistente, fechaPrestacion, setFechaPrestacion,
    idSolicitudLinea, setIdSolicitudLinea, enableCheckAfiInexistente, importe, setImporte,
    setEnableCheckAfiInexistente, coseguroFacturado, setCoseguroFacturado,
    enableCheckPractInexistente, setEnableCheckPractInexistente, practInexistente, setPractInexistente, practicaTemp,
    setPracticaTemp, codigoPractica, codigoMedicamentoRef, codigoMedicamento, setCodigoMedicamento,
    debitoCapita, setDebitoCapita, efectorFacturacionDebitoCapita, setEfectorFacturacionDebitoCapita,
    importeMedicTabla, setImporteMedicTabla, setAfiliadoExternoTemp, afiliadoExternoTemp, idObraSocial
}) => {
    const dispatch = useDispatch();

    const [idObraSocialP, setIdObraSocialP] = useState(idObraSocial ? idObraSocial : OBRAS_SOCIALES.OSPEDYC);
    const { obrasSociales = [] } = useSelector((state) => state.obrasSociales);

    useEffect(() => {
        if (obrasSociales.length === 0)
            dispatch(getObrasSociales());
        setIdObraSocialP(idObraSocialP !== null ? idObraSocialP : OBRAS_SOCIALES.OSPEDYC);
    }, [dispatch]);

    console.log("enableCheckAfiInexistente, " , enableCheckAfiInexistente)
    return (
        <>
            <Grid item xs={12}>
                {lineaComprobante === LIQUIDACIONES_LINEA_COMPORBANTE.MEDICAMENTO &&
                    <BuscadorMedicamento
                        ref={codigoMedicamentoRef}
                        cod={codigoMedicamento}
                        liquidaciones={true}
                        label="Medicamento (Presentación | Laboratorio | Nombre | Drogas)"
                        fieldsDisabled={false}
                        autorizacion={true}
                        setCod={(val) => setCodigoMedicamento(val)}
                    />}
                {lineaComprobante === LIQUIDACIONES_LINEA_COMPORBANTE.PRESTACION &&  !enableCheckAfiInexistente && (
                    <Grid container spacing={1}>
                        <Grid item sm={12}>
                                {Array.isArray(obrasSociales) && obrasSociales.length > 0 && (
                                    <Select
                                        fullWidth
                                        margin="normal"
                                        label="OS"
                                        name="idObraSocialP"
                                        value={idObraSocialP}
                                        onChange={(e) => {
                                            setIdObraSocialP(e.target.value);
                                        }}
                                        style={{
                                            // width: !props.hideTitle && 500,
                                            padding: 6,
                                            backgroundColor: "#FAFAFA",
                                            borderRadius: "5px",
                                        }}
                                    >
                                        {obrasSociales.map((ObraSocial) => (
                                            <MenuItem
                                                key={ObraSocial.idObraSocial}
                                                value={ObraSocial.idObraSocial}
                                            >
                                                {ObraSocial.siglas} - {ObraSocial.razonSocial}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                )}
                        </Grid>
                    </Grid>
                )}
                {idObraSocialP === OBRAS_SOCIALES.OSPEDYC && !enableCheckAfiInexistente &&(
                    <AutorizacionesBuscador
                        hideTitle={true}
                        liquidaciones={true}
                        afiliadoTemp={afiliadoTemp}
                        setAfiliadoTemp={setAfiliadoTemp}
                        setAfiInexistente={setAfiInexistente}
                        disabled={(enableCheckAfiInexistente || lineaExistente) && !esLineaCodigoLiq}
                        setEnableCheckAfiInexistente={setEnableCheckAfiInexistente}
                    />
                )}
                {idObraSocialP !== OBRAS_SOCIALES.OSPEDYC && !enableCheckAfiInexistente &&(
                    <BuscadorAfiliadosExternos
                        hideTitle={true}
                        liquidaciones={true}
                        afiliadoExternoTemp={afiliadoExternoTemp}
                        setAfiliadoExternoTemp={setAfiliadoExternoTemp}
                        setAfiInexistente={setAfiInexistente}
                        disabled={(enableCheckAfiInexistente || lineaExistente) && !esLineaCodigoLiq}
                        setEnableCheckAfiInexistente={setEnableCheckAfiInexistente}
                        idObraSocial={idObraSocialP}
                    />
                )}
                {/* {!esLineaCodigoLiq && */}
                    <Grid container spacing={1}>
                        <Grid item sm={6}>
                            <Paper style={{ marginTop: -5, boxShadow: 'none' }}>
                                <FormGroup row>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                name="enableCheckAfiInexistente"
                                                checked={enableCheckAfiInexistente}
                                                disabled={afiliadoTemp || lineaExistente || afiliadoExternoTemp}
                                                onChange={(e) => {
                                                    setEnableCheckAfiInexistente(e.target.checked);
                                                    setAfiliadoTemp();
                                                    setAfiliadoExternoTemp();
                                                    if (!e.target.checked)
                                                        setAfiInexistente();
                                                }}
                                            />
                                        }
                                        label="Afiliado Inexistente"
                                    />
                                </FormGroup>
                            </Paper>
                        </Grid>
                        {!esLineaCodigoLiq &&
                        <Grid item sm={6} style={{ marginTop: -5 }}>
                            <DebitoCapita
                                label={"Débito a la cápita"}
                                mouseEvent={false}
                                autorizaciones={false}
                                cargaLineaSinPrecarga={true}
                                practica={
                                    {
                                        efectorFacturacionDebitoCapita,
                                        debitoCapita
                                    }
                                }
                                setDebitoCapita={setDebitoCapita}
                                setEfectorFacturacionDebitoCapita={setEfectorFacturacionDebitoCapita}
                            />
                        </Grid>
                        }
                        {enableCheckAfiInexistente &&
                            <Grid item sm={12} style={{ marginTop: -10 }}>
                                <TextField
                                    label="Afiliado Inexistente"
                                    margin="normal"
                                    name="afiInexistente"
                                    value={afiInexistente ?? ''}
                                    autoComplete="off"
                                    onChange={(e) => { setAfiInexistente(e.target.value) }}
                                    fullWidth
                                />
                            </Grid>
                        }
                        {lineaComprobante === LIQUIDACIONES_LINEA_COMPORBANTE.PRESTACION && !esLineaCodigoLiq &&(
                            <Grid item sm={4}>
                                <Paper style={{ marginTop: -5, boxShadow: 'none' }}>
                                    <FormGroup row>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    name="enableCheckPractInexistente"
                                                    checked={enableCheckPractInexistente}
                                                    disabled={codigoPractica || lineaExistente}
                                                    onChange={(e) => {
                                                        setEnableCheckPractInexistente(e.target.checked);
                                                        setPracticaTemp();
                                                        if (!e.target.checked)
                                                            setPractInexistente();
                                                    }}
                                                />
                                            }
                                            label="Práctica Inexistente"
                                        />
                                    </FormGroup>
                                </Paper>
                            </Grid>
                        )}
                        {enableCheckPractInexistente && !esLineaCodigoLiq && (
                            <Grid item sm={8} style={{ marginTop: -10 }}>
                                <TextField
                                    label="Práctica Inexistente"
                                    margin="normal"
                                    name="practInexistente"
                                    value={practInexistente ?? ''}
                                    autoComplete="off"
                                    onChange={(e) => { setPractInexistente(e.target.value) }}
                                    fullWidth
                                />
                            </Grid>
                        )}


                    </Grid>
                {/* } */}
            </Grid>
            <Grid item xs={4}>
                <MuiPickersUtilsProvider
                    locale={esLocale}
                    utils={DateFnsUtils}
                >
                    <KeyboardDatePicker
                        margin="normal"
                        style={{ minWidth: 145 }}
                        id="dialogFechaPrestacion"
                        format="dd/MM/yyyy"
                        okLabel="Aceptar"
                        label={lineaComprobante === LIQUIDACIONES_LINEA_COMPORBANTE.MEDICAMENTO ? "Fecha Receta" : "Fecha Realización"}
                        required={true}
                        clearLabel="Limpiar"
                        cancelLabel="Cancelar"
                        maxDate={new Date()}
                        value={fechaPrestacion}
                        onChange={(date) => {
                            setFechaPrestacion(date);
                            if (lineaComprobante === LIQUIDACIONES_LINEA_COMPORBANTE.MEDICAMENTO && codigoMedicamento)
                                dispatch(getValorMedicamento(codigoMedicamento.idMedicamento, date.toISOString(), setImporteMedicTabla));
                        }}
                        KeyboardButtonProps={{
                            "aria-label": "change date",
                        }}
                    />
                </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={4}>
                <TextField
                    margin="normal"
                    name="cantidad"
                    label="Cantidad"
                    value={cantidad}
                    autoComplete="off"
                    onChange={(e) => {
                        if (e.target.value > 0) setCantidad(e.target.value)
                    }}
                    type='number'
                    required
                    fullWidth
                />
            </Grid>
            <Grid item xs={4}>
                <NumberFormat
                    style={{ marginTop: 15 }}
                    onValueChange={(values) => {
                        setImporte(values.floatValue);
                    }}
                    value={importe}
                    thousandSeparator="."
                    decimalSeparator=","
                    prefix={"$ "}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    customInput={TextField}
                    {...{ label: 'Importe', fullWidth: true, required: true }}
                />
            </Grid>
            {lineaComprobante === LIQUIDACIONES_LINEA_COMPORBANTE.PRESTACION &&
                <Grid item xs={4}>
                    <NumberFormat
                        style={{ marginTop: 15 }}
                        onValueChange={(values) => {
                            setCoseguroFacturado(values.floatValue);
                        }}
                        value={coseguroFacturado}
                        thousandSeparator="."
                        decimalSeparator=","
                        decimalScale={2}
                        fixedDecimalScale={true}
                        prefix={"$ "}
                        customInput={TextField}
                        {...{ label: 'Coseguro Facturado', fullWidth: true, required: true }}
                    />
                </Grid>
            }
            {!esLineaCodigoLiq &&
                <>
                    {comprobanteSeleccionado.comprobanteContrato.efectorFacturacion.validaPortalPrestador &&
                        <Grid item xs={6}>
                            <TextField
                                margin="normal"
                                label="Nro Validación"
                                name="nroValidacion"
                                value={nroValidacion ?? ''}
                                autoComplete="off"
                                onChange={(e) => { setNroValidacion(e.target.value) }}
                                type='number'
                                fullWidth
                            />
                        </Grid>
                    }
                    {comprobanteSeleccionado.comprobanteContrato.efectorFacturacion.validaAutorizacion &&
                        lineaComprobante !== LIQUIDACIONES_LINEA_COMPORBANTE.MEDICAMENTO &&
                        <Grid item xs={6}>
                            <TextField
                                margin="normal"
                                label="IdSolicitud"
                                name="idSolicitudLinea"
                                value={idSolicitudLinea}
                                autoComplete="off"
                                onChange={(e) => { setIdSolicitudLinea(e.target.value) }}
                                type='number'
                                fullWidth
                            />
                        </Grid>
                    }
                    {lineaComprobante === LIQUIDACIONES_LINEA_COMPORBANTE.PRESTACION &&
                        <Grid item xs={6}>
                            <FormControl fullWidth style={{ marginTop: 15 }}>
                                <InputLabel>Categoría</InputLabel>
                                <Select
                                    fullWidth
                                    label="Categoria"
                                    name="idCategoria"
                                    value={idCategoria ?? ''}
                                    onChange={(e) => setIdCategoria(e.target.value)}
                                >
                                    <MenuItem value={""}><em>Seleccione...</em></MenuItem>
                                    {CATEGORIAS_VALORIZACIONES_ARRAY.map(e => <MenuItem key={e.id} value={e.id}>{e.descripcion}</MenuItem>)}
                                </Select>
                            </FormControl>
                        </Grid>
                    }
                </>
            }
            {lineaComprobante === LIQUIDACIONES_LINEA_COMPORBANTE.MEDICAMENTO &&
                <>
                    <Grid item xs={4}>
                        <NumberFormat
                            style={{ marginTop: 15 }}
                            onValueChange={(values) => {
                                setImporteMedicTabla(values.floatValue);
                            }}
                            value={importeMedicTabla}
                            thousandSeparator="."
                            allowNegative={true}
                            decimalScale={2}
                            fixedDecimalScale={true}
                            decimalSeparator=","
                            prefix={"$ "}
                            customInput={TextField}
                            {...{
                                label: 'Importe Medicamento Tabla',
                                fullWidth: true,
                                required: true
                            }}
                        />
                    </Grid>
                </>
            }
        </>
    )
}
